export const ACCESS_TOKEN = "hgavdsVhgnasd";

export const REFRESH_TOKEN = "acjhwavdassad";

export const LANGUAGE_TOKEN = "language";

export const CONSENT_SCREEN = "consent";

export const getToken = tokenType => {
  const token = localStorage.getItem(tokenType);
  return token || null;
};

export const saveToken = (token, tokenType) => {
  localStorage.setItem(tokenType, token);
};

export const removeToken = tokenType => {
  localStorage.removeItem(tokenType);
};
